module.exports = __webpack_public_path__ + "img/cancel_white.43e49981.svg";